import { render, staticRenderFns } from "./CargoLocationDetail.vue?vue&type=template&id=7a0295e7&scoped=true"
import script from "./CargoLocationDetail.vue?vue&type=script&lang=js"
export * from "./CargoLocationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0295e7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a0295e7')) {
      api.createRecord('7a0295e7', component.options)
    } else {
      api.reload('7a0295e7', component.options)
    }
    module.hot.accept("./CargoLocationDetail.vue?vue&type=template&id=7a0295e7&scoped=true", function () {
      api.rerender('7a0295e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/CargoLocationDetail.vue"
export default component.exports